import { render } from "./SectionsList.vue?vue&type=template&id=837d0930&scoped=true"
import script from "./SectionsList.vue?vue&type=script&lang=js"
export * from "./SectionsList.vue?vue&type=script&lang=js"

import "./SectionsList.vue?vue&type=style&index=0&id=837d0930&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-837d0930"]])

export default __exports__